


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Store, StoreModel, FeatureAssignement, Timing } from '@/models/admin/store';
import { Utils } from '@/helper/utils';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
class SaveStorePreferencePage extends Base {
  public storeViewModel: any = {};
  public preferenceJson: any = {
    'ALLOW-CLOSED-RO-FOR-CUSTOMER': false,
    'ALLOW-OPEN-RO-FOR-CUSTOMER': false,
    'ALLOW-PAYMENT-ONLINE-FOR-CUSTOMER': false,
    'ALLOW-EXPENSE-PARALLEL-PROCESSING': false,
    'IS-RO-AUTOPAY-TEXT-ENABLED': false,
    'ALLOW-APPOINTMENT-MESSAGE-REMINDER': false,
    'IS-SHIPMENT-ENABLED': false,
    'IS-VENDOR-PAYMENT-ENABLED': false,
    'IS-OCR-ENABLED': false,
    'IS-FEDERAL-TAXID-REQUIRED': false,
    'IS-PRINTING-ENABLED': false,
    'IS-TRIM-FOR-PART-SCAN-ENABLED': false,
    'IS-TRIM-FROM-END-ENABLED': false,
    'IS-PART-NUMBER-NUMERIC': false,
    'IS-TRIM-FROM-BEGINNING-ENABLED': false,
    'ALLOW-AUTO-DMS-POST-REFUND': false,
    'ALLOW-PART-RECEIVE-BY-PACKET-SIZE': false,
    'IS-LIVE-CALL-ENABLE': false,
    'IS-LIVE-TRANSCRIPTION-ENABLE': false,
    'IS-GREETING-ENABLE': false,
    'IS-IP-RESTRICTION-ENABLED': false,
    'INCLUDE-STORE-MANAGER-APPROVAL-FOR-SPLIT-EXPENSE': false,
    'IS-EXPENSE-AUTO-APPROVAL-ENABLED': false,
    'IS-IMPIRA-OCR-ENABLED': false,
    'SUM-UP-MONTHLY-TAX-IN-LEASE-TOTAL': false,
    'Enable-Vendor-Request-Approval-Notification-Email': false,
    'IS-ROME-ENABLED': false,
    'IS-HIEROLOGY-ENABLED': false,
    'IS-ACCOUNTING-SERVICE-ENABLED': false,
    'IS-CUSTOMER-SERVICE-ENABLED': false,
    'IS-DEAL-SERVICE-ENABLED': false,
    'IS-REPAIR-ORDER-SERVICE-ENABLED': false,
    'IS-VEHICLE-SERVICE-ENABLED': false,
    'IS-PARTS-SERVICE-ENABLED': false,
    // 'IS-CHATGPT-ENABLED':false
    'IS-CLOSE-RO-SURVEY-ENABLED': false,
    'IS-APPOINTMENT-FOLLOWUP-ENABLED': false,
    'IS-PRE-CSI-SECONDARY-TEXT-ENABLED': false,
    'VEHICLE-EVALUATION-NOTIFICATION-THREE-DAYS-BEFORE': false,
    'VEHICLE-EVALUATION-NOTIFICATION-ONE-DAY-BEFORE': false,
    'PART-SALE-QR-CODE-PAYMENT-OVERRIDE-CC-FEE-APPLIED': true,
    'IS-PART-SALE-QR-CODE-PAYMENT-ENABLED': false,
    'IS-CUT-OFF-DATE-ENABLED': false,
    'IS-AR-CREDIT-BALANCE-STATEMENT-ENABLED': false,
    'IS-AR-STATEMENT-DISCLOSURE-CONSENT-ENABLED': false
  };
  get days(): string {
    if (this.timingModel) {
      return this.timingModel.from + '-' + this.timingModel.to;
    }
    return '';
  }
  public timingModel: Timing = {
    days: this.days,
    to: '',
    from: '',
    startTime: '00:00',
    endTime: '00:00',
  };
  public storeModel: StoreModel = {};
  public form: any = {};
  public storePreferenceFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public requestProgress: boolean = false;
  public isbypassDisabled: boolean = true;
  public users: any[] = [];
  public smsSendingDays: any[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  public accountPayableUsers: any[] = [];
  public isStoreManagerRequired: boolean = false;
  public isCreditCardFeeEnabled: boolean = false;
  public isCreditCardFeeTaxable: boolean = false;
  public creditCardFeePercentage: number = 0;
  public creditCardTaxPercentage: number = 0;

  public isShowPercentServiceCharge: boolean = false;
  public isPrimaryPromptFilled: boolean = false;

  public smsExcludeYear: string[] = Array.from(

    { length: 9 }, // 8 years before + current year
    (_, i) => ((new Date().getFullYear()) - 8 + i).toString()
  );

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'Preference' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'backToStoreAdd') {
      this.$router
        .push({
          name: 'admin.stores.add',
          params: {
            tenantId: this.tenantId.toString(),
            enterpriseId: this.enterpriseId.toString(),
            tab: 'Preference',
          },
        })
        .catch((ex) => {
          console.log(ex);
        });
    } else if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, this.$t('stores.features.alertInvalidForm'));
        this.resetMethodName(methodName);
        return;
      }
      this.saveStorePreferences();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    } else {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreAdd',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
      this.getStoreInfo();
    }
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.getUsers();
    this.getAccountPayableUsers();
  }
  public setPreferenceFields(): void {
    this.storePreferenceFields = [
      {
        key: "wrapperHeading1",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Features</h2></span>'
      },
      {
        key: 'selectedFeatures',
        required: false,
        type: 'v-alynk-features',
        templateOptions: {
          disabled: false,
          multiple: true,
          label: this.$t('stores.features.lblSelectFeatures') as string,
          validations: '',
          loading: false,
          events: {
            onChange: (features: FeatureAssignement[], values: number[]) => {
              if (Array.isArray(values)) {
                const filteredFeatures = features.filter((m) => {
                  return values.find((j) => {
                    return m.featureId === j;
                  });
                });
                this.storeModel.featureJson = filteredFeatures;
                this.setMessagingField();
              }
            },
          },
        },
      },
      {
        key: "wrapperHeading2",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">DMS Licensing Feature</h2></span>'
      },
      {
        key: 'IS-ACCOUNTING-SERVICE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Accounting Service",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'IS-CUSTOMER-SERVICE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Customer Service",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-DEAL-SERVICE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Deal Service",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-REPAIR-ORDER-SERVICE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Repair Order Service",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-VEHICLE-SERVICE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Vehicle Service",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-PARTS-SERVICE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Parts Service",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading3",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Preference Config</h2></span>'
      },
      {
        key: 'ALLOW-OPEN-RO-FOR-CUSTOMER',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblAllowOpenRoForCustomer') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'ALLOW-AUTO-DMS-POST-REFUND',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Allow Auto Dms Post for Refund',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ALLOW-CLOSED-RO-FOR-CUSTOMER',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.features.lblAllowClosedRoForCustomer'
          ) as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ALLOW-PAYMENT-ONLINE-FOR-CUSTOMER',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.features.lblAllowPaymentOnlineForCustomer'
          ) as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ALLOW-EXPENSE-PARALLEL-PROCESSING',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.features.lblAllowExpenseParallerProcessing'
          ) as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-RO-AUTOPAY-TEXT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsRoAutoPayTextEnabled') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ALLOW-APPOINTMENT-MESSAGE-REMINDER',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.features.lblAllowAutoAppointmentTextReminder'
          ) as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-SHIPMENT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsShipmentEnabled') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-VENDOR-PAYMENT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsVendorPaymentEnabled') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-OCR-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblISOcrEnabled') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-FEDERAL-TAXID-REQUIRED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.features.RequireFederalTaxIdForExpenseSubmission'
          ) as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-LIVE-CALL-ENABLE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Allow Live Calls',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-LIVE-TRANSCRIPTION-ENABLE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: true,
          label: 'Allow Live Transcription',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-IP-RESTRICTION-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Enable IP Restriction',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'UPDATE-LOCATION-ON-RFID-CAPTURE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Update Location On RFID Capture',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-GREETING-ENABLE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Allow Is Greeting Enable',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left ',
        },
      },
      {
        key: 'INCLUDE-STORE-MANAGER-APPROVAL-FOR-SPLIT-EXPENSE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Include Store Manager Approval For Split Expense',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          events: {
            onChange: (item, val) => {
              this.updateFiledValus(item);
            },
          },
        },
      },
      {
        key: 'IS-EXPENSE-AUTO-APPROVAL-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Expense Auto Approval Enabled',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-IMPIRA-OCR-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Butler Ocr Enabled',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'SUM-UP-MONTHLY-TAX-IN-LEASE-TOTAL',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Sum Up Monthly Tax In Lease Total',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'Enable-Vendor-Request-Approval-Notification-Email',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Enable Vendor Request Approval Notification Email',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-ROME-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Rome Enabled',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-HIEROLOGY-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Hierology Enabled',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-Auto-Approve-Scanned-Invoice',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Auto Approve Scanned Invoice',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-VEHICLE-FTP-UPLOAD-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Upload Vehicle Description On FTP',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-TERMINAL-PAYMENT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Allow Terminal Payment',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      // {
      //   key: 'IS-CHATGPT-ENABLED',
      //   required: false,
      //   type: 'v-alynk-switch',
      //   templateOptions: {
      //     disabled: false,
      //     display: true,
      //     label: 'Is ChatGPT Enabled',
      //     validations: '',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      {
        key: "wrapperHeading4",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections" style="margin-top: 54%">Mobile App Config</h2></span>'
      },
      {
        key: 'IS-PRINTING-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsPrintingEnabled') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'IS-PART-NUMBER-NUMERIC',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsPartNumberNumeric') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ALLOW-PART-RECEIVE-BY-PACKET-SIZE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Allow Part Receive By Packet Size In Mobile App',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-TRIM-FOR-PART-SCAN-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t(
            'stores.features.lblIsTrimForPartScanEnabled'
          ) as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-TRIM-FROM-BEGINNING-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsTrimFromBeginning') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-TRIM-FROM-END-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblIsTrimFromEnd') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'IS-PACKING-SLIP-NUMBER-REQUIRED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Is Packing Slip Number Required',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'REGEX-BEGINNING-TRIM',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: "Regex for Begining Trim",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'BEGINNING-TRIM-LENGTH',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblBeginningTrimLenght') as string,
          validations: '',
          display: true,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'REGEX-END-TRIM',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: "Regex for Ending Trim",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'END-TRIM-LENGTH',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblBeginningTrimLenght') as string,
          validations: '',
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'REGEX-QR-CODE-TRIM',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: "Regex for QR Code Trim",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'MOBILE-APP-RUNNING-VERSION',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: true,
          display: true,
          label: "Latest Mobile App Version",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading5",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          display: false,
          label: 'Repair Order Line Item Credit Card Fee',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Repair Order Line Item Credit Card Fee</h2></span>'
      },
      {
        key: 'IS-CREDIT-CARD-FEE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Credit Card Fee',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
          events: {
            onChange: (item, val) => {
              this.updateFiledValus(item, 'creditCardFee');
            },
          },
        },
      },
      {
        key: 'IS-CREDIT-CARD-FEE-TAXABLE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: !this.isCreditCardFeeEnabled,
          //display : this.isCreditCardFeeEnabled,
          label: 'Credit Card Fee Taxable',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          events: {
            onChange: (item) => {
              this.updateFiledValus(item, 'creditCardTax');
            },
          },
        },
      },
      {
        key: 'CREDIT-CARD-FEE-PERCENTAGE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: !this.isCreditCardFeeEnabled,
          //display : this.isCreditCardFeeEnabled,
          label: 'Credit Card Fee Percentage',
          validations: '',
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',

        },
      },
      {
        key: 'CREDIT-CARD-TAX-PERCENTAGE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: !this.isCreditCardFeeTaxable,
          //display : this.isCreditCardFeeEnabled,
          label: 'Credit Card TAX Percentage',
          validations: '',
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading6",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          display: false,
          label: 'Order Service Charges',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Order Service Charges</h2></span>'
      },
      {
        key: 'IS-ORDER-SERVICE-CHARGE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Order Service Charge Enabled',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'IS-ORDER-SERVICE-CHARGE-PERCENTAGE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Is Charge By Percent',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          events: {
            onChange: (item, val) => {
              this.updateFiledValus(item, 'orderServiceCharge');
            },
          },
        },
      },
      {
        key: 'ORDER-SERVICE-CHARGE-PERCENTAGE-VALUE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Percentage Value',
          validations: '',
          display: this.isShowPercentServiceCharge,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ORDER-SERVICE-CHARGE-FIXED-AMOUNT',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Fixed Amount',
          validations: '',
          display: !this.isShowPercentServiceCharge,
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0  float-left',
        },
      },
      {
        key: 'ORDER-SERVICE-CHARGE-NAME',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Service Charge Name',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading7",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Deal Config</h2></span>'
      },
      {
        key: 'DEAL-FETCH-DAYS',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblDealFetchDays') as string,
          validations: '',
          type: 'number',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: "wrapperHeading8",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Ar Statement Info</h2></span>'
      },
      {
        key: 'AR-PHONE-NUMBER',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          prefix: '+1',
          counter: 10,
          display: true,
          label: this.$t('stores.features.lblArPhoneNumber') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: 'AR-STATEMENT-FROM-EMAIL',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: this.$t('stores.features.lblArSatementFromEmail') as string,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.Email(v)
          ]
        },
      },
      {
        key: 'IS-AR-CREDIT-BALANCE-STATEMENT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Send AR Statements to Customers with Credit Balance',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-0 float-left',
        },
      },
      {
        key: 'IS-AR-STATEMENT-DISCLOSURE-CONSENT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: 'Consent: There is a non-negotiable 3% finance charge if invoices exceed the net 30 and/or net due by 10th payment term.',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 mt-0 float-left',
        },
      },
      {
        key: "wrapperHeading8",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Contact Info</h2></span>'
      },
      {
        key: 'MESSAGING-PHONE-NUMBER',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          prefix: '+1',
          counter: 10,
          label: this.$t('stores.features.lblMesagingPhoneNumber') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: 'ReturnAddressId',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: this.$t('stores.features.lblReturnAddressId') as string,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading8",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Vehicle Evaluation Config</h2></span>'
      },
      {
        key: 'VEHICLE-EVALUATION-MESSAGING-PHONE-NUMBER',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          prefix: '+1',
          counter: 10,
          label: "Vehicle Evaluation Messaging Phone Number",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: 'VEHICLE-EVALUATIONS-COORDINATOR',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Vehicle Evaluations Coordinator',
          text: 'email',
          value: 'id',
          items: this.users,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n2 float-left',
        },
      },
      {
        key: 'XML-EMAIL-FOR-VEHICLE-EVALUATION',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: "Adf Xml Emails for Vehicle Evaluation",
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.Email(v)
          ]
        },
      },
      {
        key: 'ADF-XML-PROVIDER-NAME',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Adf Xml Provider Name',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'ADF-XML-SERVICE-DESCRIPTION',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Adf Xml Service Description',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'EVALUATION-CUSTOMER-PHONE-NUMBER',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          prefix: '+1',
          counter: 10,
          label: "Evaluation Customer Phone Number",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: 'VEHICLE-EVALUATION-NOTIFICATION-DAY-SCHEDULE',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Vehicle Evaluation Notification Day Schedule',
          value: 'id',
          items: this.smsSendingDays,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n2 float-left',
        },
      },
      {
        key: 'VEHICLE-EVALUATION-NOTIFICATION-EXCLUDE-YEAR',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Vehicle Evaluation Notification Exclude Year',
          value: 'id',
          items: this.smsExcludeYear,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n2 float-left',
        },
      },
      {
        key: 'VEHICLE-EVALUATION-NOTIFICATION-THREE-DAYS-BEFORE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: true,
          display: true,
          label: 'Vehicle Evaluation Notification Message (3 Days Before)',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'VEHICLE-EVALUATION-NOTIFICATION-ONE-DAY-BEFORE',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Vehicle Evaluation Notification Message',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'VEHICLE-EVALUATION-NOTIFICATION-START-TIME',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          display: false,
          label: 'Vehicle Evaluation Notification-Start-Time',
          events: {
            onChange: (val) => {
              this.timingModel.startTime = this.$moment(val, 'HH:mm').format('hh:mm A');
            },
          },
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0  float-left',
          appendIcon: 'event'
        },
      },
      {
        key: "wrapperHeading9",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Part Sale Qr-Code Payment Config</h2></span>'
      },
      {
        key: 'IS-PART-SALE-QR-CODE-PAYMENT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Is Part Sale QR Code Payment Enabled",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left mt-5',
        },
      },
      {
        key: 'PART-SALE-QR-CODE-PAYMENT-OVERRIDE-CC-FEE-APPLIED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Include Credit Card Fee",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left ',
          events: {
            onChange: (item, val) => {
              this.updateFiledValus(item, 'isCreditCardFeeIncluded');
            },
          }
        },
      },
      {
        key: 'PART-SALE-QR-CODE-PAYMENT-OVERRIDE-DISABLED-REASON',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: this.isbypassDisabled,
          label: 'Reason For Disabling',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading10",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">CPO Config</h2></span>'
      },
      {
        key: 'CPO-ACCOUNT',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'CPO Account',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'CPO-CHARGE-AMOUNT',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'CPO Charge Amount',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'CPO-SALE-GROUP',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'CPO Sale Group',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading10",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">User Config</h2></span>'
      },
      {
        key: 'selectedStoreManager',
        required: this.isStoreManagerRequired,
        type: 'v-alynk-select',
        templateOptions: {
          required: this.isStoreManagerRequired,
          disabled: false,
          label: 'Store Manager',
          text: 'email',
          value: 'id',
          items: this.users,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n3 float-left',
          rules: [
            v => this.isStoreManagerRequired ? this.required('Store Manager', v) : true
          ]
        },
      },
      {
        key: 'DefaultApScanUser',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Default Ap Scan User',
          text: 'email',
          value: 'email',
          items: this.accountPayableUsers,
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'Parts-Manager',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Parts Manager',
          text: 'email',
          value: 'id',
          items: this.users,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n1 float-left',
        },
      },
      {
        key: 'Service-Manager',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Service Manager',
          text: 'email',
          value: 'id',
          items: this.users,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-n1 float-left',
        },
      },
      {
        key: "wrapperHeading11",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Expense Config</h2></span>'
      },
      {
        key: 'EXPENSE-AUTO-APPROVAL-HOURS',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          type: 'number',
          label: 'Expense Hours Until Auto Approve',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'MONTHLY-VENDOR-CONSUMABLE-AMOUNT-PERCENTAGE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          type: 'number',
          label: 'Monthly Vendor Report Amount Percentage',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'Outstanding-Expense-CC-Email',
        type: 'v-alynk-select',
        templateOptions: {
          disabled: false,
          label: 'Oustanding CC Emails',
          text: 'email',
          value: 'id',
          items: this.users,
          loading: false,
          multiple: true,
          chips: true,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading11",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Close Ro Survey Config</h2></span>'
      },
      {
        key: 'IS-CLOSE-RO-SURVEY-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Is Close Ro Survey Enabled",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'IS-PRE-CSI-SECONDARY-TEXT-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Is Pre Csi Secondary Text Enabled",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'HOURS-TO-SEND-PRE-CSI-SECONDARY-TEXT',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          type: 'number',
          label: 'Hours After Secondary Text To Be Sent',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'PRE-CSI-TEXT-DELAY-TIME',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          type: 'number',
          label: 'Pre-CSI Text Delay Time (in Minutes)',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0  mb-2 float-left',
        },
      },
      {
        key: "wrapperHeading56",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Charge Customer Config</h2></span>'
      },
      {
        key: 'IS-CUT-OFF-DATE-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Use Cut-off Date",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: "wrapperHeading25",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Ro Follow Up Message Timing</h2></span>'
      },
      {
        key: 'RO-FOLLOWUP-START-TIME',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          display: false,
          label: 'Ro Follow Up Start Time',
          events: {
            onChange: (val) => {
              this.timingModel.startTime = this.$moment(val, 'HH:mm').format('hh:mm A');
            },
          },
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: 'RO-FOLLOWUP-END-TIME',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          display: false,
          label: 'Ro Follow Up End Time',
          events: {
            onChange: (val) => {
              this.timingModel.startTime = this.$moment(val, 'HH:mm').format('hh:mm A');
            },
          },
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-0  mb-2 float-left',
        },
      },
      {
        key: "wrapperHeading25",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Schedule Payment Time</h2></span>'
      },
      {
        key: 'Schedule-Payment-Start-Time',
        required: false,
        type: 'v-alynk-timepicker',
        templateOptions: {
          disabled: false,
          display: false,
          label: 'Schedule Payment Start Time',
          events: {
            onChange: (val) => {
              this.timingModel.startTime = this.$moment(val, 'HH:mm').format('hh:mm A');
            },
          },
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 mt-5 float-left',
        },
      },
      {
        key: "wrapperHeading11",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Appointment Followup Config</h2></span>'
      },
      {
        key: 'IS-APPOINTMENT-FOLLOWUP-ENABLED',
        required: false,
        type: 'v-alynk-switch',
        templateOptions: {
          disabled: false,
          label: "Is Appointment Followup Enabled",
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading11",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">For Negative Feedback Instructions</h2></span>'
      },
      {
        key: 'CLOSE-RO-GPT-INSTRUCTIONS-IF-NEGATIVE',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'ChatGpt Instructions If Negative',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading11",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">For Positive Feedback Instructions</h2></span>'
      },
      {
        key: 'CLOSE-RO-GPT-INSTRUCTIONS-IF-POSITIVE',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'ChatGpt Instructions If Positive ',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading12",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Check Max Approval Amount</h2></span>'
      },
      {
        key: 'CHECK-MAX-APPROVAL-AMOUNT',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          type: 'number',
          label: 'Approval Amount',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-5 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading13",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Payment Config</h2></span>'
      },
      {
        key: 'CREDIT-CARD-DISCLAIMER',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Disclaimer',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading13",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Bot Configuration</h2></span>'
      },
      // {
      //   key: 'BotFeedbackCategorizationPrompt',
      //   required: false,
      //   type: 'v-alynk-textarea',
      //   templateOptions: {
      //     disabled: false,
      //     display: true,
      //     label: 'Bot Feedback Categorization Prompt',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
      //   }
      // },
      // {
      //   key: 'PrimaryPrompt',
      //   required: false,
      //   type: 'v-alynk-textarea',
      //   templateOptions: {
      //     disabled: false,
      //     display: true,
      //     label: 'Primary Prompt',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
      //   },
      // },
      {
        key: 'SupplementaryPrompt',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: true,
          display: true,
          label: 'Supplementary Prompt',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading13",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">DMV Form Verifier Config</h2></span>'
      },
      {
        key: 'DMV-VERIFIER-NAME',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Verifier Name',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-5 pl-0 float-left',
        },
      },
      {
        key: 'DMV-LICENSE-NUMBER',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'TITLE/ID/BADGE/VV LICENSE NUMBER',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-ADDRESS',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Address',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-CITY',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'City',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-STATE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'State',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-TELEPHONE-NUMBER',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          type: 'number',
          label: 'Telephone Number',
          counter: 10,
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-PHYSICALLY-VERIFIED-CITY',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Physically Verified City',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-PHYSICALLY-VERIFIED-STATE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Physically Verified State',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-EXECUTED-PLACE',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Executed At (Place Signed - City, State)',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: 'DMV-VERIFIER-EMAIL',
        required: false,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'Verifier Email',
          validations: '',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
        },
      },
      {
        key: "wrapperHeading13",
        type: 'v-alynk-label',
        templateOptions: {
          disabled: true,
          label: '',
        },
        wrapper: '<span class="col-12"><h2 class="storeSections">Zebra Printer Config</h2></span>'
      },
      {
        key: 'RfidLabelsZpl',
        required: false,
        type: 'v-alynk-textarea',
        templateOptions: {
          disabled: false,
          display: true,
          label: 'RFID Labels ZPL',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-0 float-left',
        },
      },
      // {
      //   key: null,
      //   type: 'v-alynk-label',
      //   templateOptions: {
      //     disabled: true,
      //     label: '',
      //   },
      //   wrapper: '<span class="col-12"><h2 class="storeSections">Work Day Config</h2></span>'
      // },
      // {
      //   key: 'WORK-DAY-USERNAME',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     display: true,
      //     label: 'Username ',
      //     validations: '',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-5 pl-0 float-left',
      //   },
      // },
      // {
      //   key: 'WORK-DAY-PASSWORD',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     display: true,
      //     label: 'Password',
      //     validations: '',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-0 float-left',
      //   },
      // },
      // {
      //   key: null,
      //   type: 'v-alynk-label',
      //   templateOptions: {
      //     disabled: true,
      //     label: '',
      //   },
      //   wrapper: '<span class="col-12"><h2 class="storeSections">Face App Config</h2></span>'
      // },
      // {
      //   key: 'LUXAND-TOKEN',
      //   required: false,
      //   type: 'v-alynk-text-field',
      //   templateOptions: {
      //     disabled: false,
      //     display: true,
      //     label: 'Token',
      //     validations: '',
      //     loading: false,
      //     elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 mt-5 pl-0 float-left',
      //   },
      // },
    ];
    this.setMessagingField();
  }
  public setMessagingField(): void {
    const messaging = this.storeModel?.featureJson && this.storeModel.featureJson.find(
      (f) => f.key === 'MESSAGING'
    );
    const messagingField = this.storePreferenceFields.find((f) => {
      return f.key === 'MESSAGING-PHONE-NUMBER';
    });
    if (messaging) {
      if (messagingField) {
        messagingField.templateOptions.display = true;
      }
    } else {
      if (messagingField) {
        messagingField.templateOptions.display = false;
      }
    }
  }

  public validateStorePreference(): Vue & { validate: () => boolean } {
    return this.$refs.storePreferenceForm as Vue & { validate: () => boolean };
  }

  public updateFiledValus(val, type = 'store') {
    this.formlyShowSkeleton(this.storePreferenceFields);
    if (type == undefined || type == 'store') {
      this.isStoreManagerRequired = val;
    }
    if (type == 'creditCardFee') {
      this.isCreditCardFeeEnabled = val;
      if (val == false) {
        this.preferenceJson['IS-CREDIT-CARD-FEE-TAXABLE'] = false;
        this.isCreditCardFeeTaxable = false;
      }
    }
    if (type === 'isCreditCardFeeIncluded') {
      if (val === true) {
        this.preferenceJson['PART-SALE-QR-CODE-PAYMENT-OVERRIDE-DISABLED-REASON'] = '';
        this.isbypassDisabled = val;
      }
      else {
        this.isbypassDisabled = val;
      }


    }

    if (type == 'orderServiceCharge') {
      this.isShowPercentServiceCharge = val;
      if (val == false) {
        this.preferenceJson['IS-ORDER-SERVICE-CHARGE-PERCENTAGE'] = false;
        this.isShowPercentServiceCharge = false;
      }
    }

    if (type == 'creditCardTax') {
      this.isCreditCardFeeTaxable = val;
    }
    this.setPreferenceFields();
    //this.setPreference();
    this.formlyHideSkeleton(this.storePreferenceFields);
  }

  public async saveStorePreferences(): Promise<void> {
    if (this.validateStorePreference().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        this.storeModel.preferenceJson = [];
        const keys = Object.keys(this.preferenceJson);
        keys.forEach((key) => {
          if (key !== 'selectedFeatures') {
            let value = this.preferenceJson[key];

            if (key == "Parts-Manager"
              || key == "Outstanding-Expense-CC-Email"
              || key == "Service-Manager"
              || key == "VEHICLE-EVALUATIONS-COORDINATOR"
              || key == "selectedStoreManager"
              || key == "VEHICLE-EVALUATION-NOTIFICATION-DAY-SCHEDULE"
              || key == "VEHICLE-EVALUATION-NOTIFICATION-EXCLUDE-YEAR"
            ) {
              value = value.toString();
            }

            if (typeof value === 'boolean') {
              value = value === false ? 'disabled' : 'enabled';
            }
            if (typeof value === 'object') {
              value = JSON.stringify(value);
            }
            this.storeModel.preferenceJson.push({
              key,
              value,
            });
          }
        });
        const isCcFeeApplied =
          this.preferenceJson['PART-SALE-QR-CODE-PAYMENT-OVERRIDE-CC-FEE-APPLIED'];

        const disableReason =
          this.preferenceJson['PART-SALE-QR-CODE-PAYMENT-OVERRIDE-DISABLED-REASON'];

        if (isCcFeeApplied === false && (!disableReason || !disableReason.trim())) {
          this.showAlert(
            false,
            'Reason For Disabling is required when Credit Card Fee is not included.'
          );
          return;
        }
        await storeService.saveFeatureAndPreferences(this.storeModel);
        this.storeViewModel.preferenceJson = this.storeModel.preferenceJson;
        this.storeViewModel.featureJson = this.storeModel.featureJson;
        this.showAlert(true, this.$t('stores.features.alertFeaturesSaved'));
        this.$router
          .push({
            name: 'admin.stores.edit',
            params: {
              tenantId: this.tenantId.toString(),
              enterpriseId: this.enterpriseId.toString(),
              storeId: this.storeId.toString(),
              tab: 'Preference'
            },
          })
          .catch((ex) => {
            console.log(ex);
          });
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storePreferenceFields);
      const response = await storeService.getStore(this.storeId);
      this.storeViewModel = response;
      this.phoneNumberFormat();
      this.storeViewModel.preferenceJson = response.preferenceJson || [];
      this.storeModel.id = this.storeViewModel.id;
      this.storeViewModel.featureJson = this.storeViewModel.featureJson || [];
      this.storeModel.featureJson = this.storeViewModel.featureJson;

      let isCreditFeeTaxable: boolean = false;

      this.storeViewModel.preferenceJson.forEach((pre) => {
        if (pre.key == 'INCLUDE-STORE-MANAGER-APPROVAL-FOR-SPLIT-EXPENSE') {
          this.isStoreManagerRequired = pre.value == 'enabled';
        }
        if (pre.key == 'IS-CREDIT-CARD-FEE-ENABLED') {
          this.isCreditCardFeeEnabled = pre.value == 'enabled';
        }
        if (pre.key == "IS-CREDIT-CARD-FEE-TAXABLE") {
          isCreditFeeTaxable = pre.value == 'enabled';
        }

        if (pre.key == "IS-ORDER-SERVICE-CHARGE-PERCENTAGE") {
          this.isShowPercentServiceCharge = pre.value == 'enabled';
        }
        if (pre.key == "PrimaryPrompt" && pre.value) {

          this.isPrimaryPromptFilled = true;
        }
        if (pre.key === 'PART-SALE-QR-CODE-PAYMENT-OVERRIDE-CC-FEE-APPLIED') {
          this.updateFiledValus(pre.value === "enabled", 'isCreditCardFeeIncluded');
        }
      });

      if (this.isCreditCardFeeEnabled) {
        this.isCreditCardFeeTaxable = isCreditFeeTaxable;
      }

      const partsManagerIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == "Parts-Manager");
      if (partsManagerIndex > -1) {
        let values = this.storeViewModel.preferenceJson[partsManagerIndex].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[partsManagerIndex].value = values;
        }
      }

      const serviceManagerIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == "Service-Manager");
      if (serviceManagerIndex > -1) {
        let values = this.storeViewModel.preferenceJson[serviceManagerIndex].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[serviceManagerIndex].value = values;
        }
      }

      const storeManagerIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == "selectedStoreManager");
      if (storeManagerIndex > -1) {
        let values = this.storeViewModel.preferenceJson[storeManagerIndex].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[storeManagerIndex].value = values;
        }
      }


      const expenseCcManager = this.storeViewModel.preferenceJson.findIndex(x => x.key == "Outstanding-Expense-CC-Email");
      if (expenseCcManager > -1) {
        let values = this.storeViewModel.preferenceJson[expenseCcManager].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[expenseCcManager].value = values;
        }
      }



      const evaluationsCoordinatorIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == "VEHICLE-EVALUATIONS-COORDINATOR");
      if (evaluationsCoordinatorIndex > -1) {
        let values = this.storeViewModel.preferenceJson[evaluationsCoordinatorIndex].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[evaluationsCoordinatorIndex].value = values;
        }
      }

      const daysIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == "VEHICLE-EVALUATION-NOTIFICATION-DAY-SCHEDULE");
      if (daysIndex > -1) {
        let values = this.storeViewModel.preferenceJson[daysIndex].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[daysIndex].value = values;
        }
      }

      const yearIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == "VEHICLE-EVALUATION-NOTIFICATION-EXCLUDE-YEAR");
      if (yearIndex > -1) {
        let values = this.storeViewModel.preferenceJson[yearIndex].value.split(',');
        if (values != undefined && values != '') {
          this.storeViewModel.preferenceJson[yearIndex].value = values;
        }
      }

      this.setPreferenceFields();
      this.setPreference();

    } finally {
      this.formlyHideSkeleton(this.storePreferenceFields);
    }
  }

  public phoneNumberFormat() {
    const messagingNumberIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == 'MESSAGING-PHONE-NUMBER');
    const arNumberIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == 'AR-PHONE-NUMBER');
    const vehicleEvaluationNumberIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == 'VEHICLE-EVALUATION-MESSAGING-PHONE-NUMBER');
    const evaluationCustomerNumberIndex = this.storeViewModel.preferenceJson.findIndex(x => x.key == 'EVALUATION-CUSTOMER-PHONE-NUMBER');

    if (messagingNumberIndex > -1) {
      const messagingNumber = this.storeViewModel.preferenceJson[messagingNumberIndex].value;
      if (messagingNumber != undefined && messagingNumber != '') {
        this.storeViewModel.preferenceJson[messagingNumberIndex].value = messagingNumber.replace(/^[+]1/, '', messagingNumber);
      }
    }
    if (arNumberIndex > -1) {
      const arNumber = this.storeViewModel.preferenceJson[arNumberIndex].value;
      if (arNumber != undefined && arNumber != '') {
        this.storeViewModel.preferenceJson[arNumberIndex].value = arNumber.replace(/^[+]1/, '', arNumber);
      }
    }

    if (vehicleEvaluationNumberIndex > -1) {
      const evaluationNumber = this.storeViewModel.preferenceJson[vehicleEvaluationNumberIndex].value;
      if (evaluationNumber != undefined && evaluationNumber != '') {
        this.storeViewModel.preferenceJson[vehicleEvaluationNumberIndex].value = evaluationNumber.replace(/^[+]1/, '', evaluationNumber);
      }
    }

    if (evaluationCustomerNumberIndex > -1) {
      const evaluationCustomerNumber = this.storeViewModel.preferenceJson[evaluationCustomerNumberIndex].value;
      if (evaluationCustomerNumber != undefined && evaluationCustomerNumber != '') {
        this.storeViewModel.preferenceJson[evaluationCustomerNumberIndex].value = evaluationCustomerNumber.replace(/^[+]1/, '', evaluationCustomerNumber);
      }
    }

  }
  public async getUsers(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storePreferenceFields);
      const storeUsers = await userService.getStoreUsers(this.storeId);
      this.users = storeUsers.results;
      this.setPreferenceFields();
      this.setPreference();
    } finally {
      this.formlyHideSkeleton(this.storePreferenceFields);
    }
  }

  public async getAccountPayableUsers(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.storePreferenceFields);
      const accountPayableUsers = await userService.getStoreUsersByRole(this.storeId, "AccountsPayable");
      this.accountPayableUsers = accountPayableUsers.results;
      this.setPreferenceFields();
      this.setPreference();
    } finally {
      this.formlyHideSkeleton(this.storePreferenceFields);
    }
  }

  public setPreference() {
    const preference = this.storeViewModel.preferenceJson || [];
    preference.forEach((pre) => {
      // if(pre.key=='INCLUDE-STORE-MANAGER-APPROVAL-FOR-SPLIT-EXPENSE')
      // {
      //   this.isStoreManagerRequired=pre.value=='enabled';
      // }
      this.preferenceJson[pre.key] =
        pre.value === 'enabled'
          ? true
          : pre.value !== 'enabled' && pre.value !== 'disabled'
            ? pre.value
            : false;
    });
    this.preferenceJson.selectedFeatures = this.storeViewModel?.featureJson && this.storeViewModel.featureJson.map(
      (f) => {
        return f.featureId;
      }
    );
  }
}
export default SaveStorePreferencePage;
